import clsx from 'clsx'
import type { LinkAttachment as LinkAttachmentType } from '@/utils/fetchers/attachment'
import LinkCard from '../Post/PostTargetCard/LinkCard'
import Attachment, { AttachmentProps } from './Attachment'
import styles from './LinkAttachment.module.css'

export interface LinkAttachmentProps extends AttachmentProps {
	data: LinkAttachmentType
	onDelete?: () => void
}

export default function LinkAttachment({
	data,
	onDelete,
	className,
	...props
}: LinkAttachmentProps) {
	return (
		<Attachment onClose={onDelete} className={clsx(styles.root, className)} {...props}>
			<LinkCard data={data.linkInfo} />
		</Attachment>
	)
}
